import { createAction, props } from "@ngrx/store";
import { FlexRule } from "../interfaces/State/Flex/FlexRule";

export const setOpenedFlex = createAction('setOpenedFlex', props<{flex: FlexRule}>())